import { render } from "./arraysComponent.vue?vue&type=template&id=742c3880&scoped=true"
import script from "./arraysComponent.vue?vue&type=script&lang=js"
export * from "./arraysComponent.vue?vue&type=script&lang=js"

import "./arraysComponent.vue?vue&type=style&index=0&id=742c3880&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742c3880"]])

export default __exports__